import React from 'react';

interface DealPriceProps {
  label: string;
  price: string;
  color?: string;
  isStrikethrough?: boolean;
  isBold?: boolean;
}

const DealPrice: React.FC<DealPriceProps> = ({ 
  label, 
  price, 
  color,
  isStrikethrough,
  isBold
}) => {
  return (
    <div className="flex justify-between items-center">
      <span className={`text-gray-500 ${isBold ? 'font-medium' : ''}`}>{label} :</span>
      <span 
        className={`
          ${isStrikethrough ? 'line-through text-gray-400' : ''}
          ${isBold ? 'font-bold' : ''}
        `}
        style={color ? { color } : undefined}
      >
        {price}
      </span>
    </div>
  );
};

export default DealPrice;